// extracted by mini-css-extract-plugin
export default {"small":"AdornmentIcons_small__-vIQJ"};